export default {
  speaker_event: [],
  events: [],
  events_list: [],
  speakers: [],
  congress: [],
  rooms: [],
  statistics: {},
}
